import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { config } from '../../../../utils/config';
import Button from '../../../atoms/Button';
import Modal from '../../../atoms/Modal';
import EmailField from '../../../fields/EmailField';
import PasswordField from '../../../fields/PasswordField';
import { EmbeddedAuthBaseProps } from '../../../organisms/EmbeddedAuth';
import ThirdPartySignIn from '../ThirdPartySignIn';
import ForgotPassword from './ForgotPassword';
import './style.scss';

const SignIn = ({ isEmbeddedAuth, isWelcomeBack }: EmbeddedAuthBaseProps & { isWelcomeBack?: boolean }) => {
  const { submitForm, isSubmitting, values } = useFormikContext<{ email: string }>();
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const toggleForgotPassword = () => setShowForgotPasswordModal(!showForgotPasswordModal);
  const thirdPartySignInConfig = config.features.thirdPartySignIn;
  const shouldShowFirstPartySignIn = !thirdPartySignInConfig.disableFirstPartySignIn;
  const shouldShowThirdPartySignIn = thirdPartySignInConfig.enabled && !!thirdPartySignInConfig.providers.length;

  const testIdPrefix = 'login';

  return (
    <div className="option__form">
      <div className="form">
        {shouldShowFirstPartySignIn && (
          <>
            {showForgotPasswordModal && (
              <Modal>
                <ForgotPassword onClose={toggleForgotPassword} initialEmail={values.email} />
              </Modal>
            )}
            <div className="form__row">
              <div className="form__field-container">
                <EmailField testIdPrefix={testIdPrefix} autocomplete="username" type="signIn" />
              </div>
            </div>
            <div className="form__row">
              <div className="form__field-container">
                <PasswordField testIdPrefix={testIdPrefix} type="signIn" autocomplete="current-password" />
              </div>
            </div>
            <div className="form__row">
              <div className="form__field-container">
                <span
                  className="auth-form__forgot-password"
                  data-test-id="login-forgot-password"
                  onClick={toggleForgotPassword}
                >
                  <FormattedMessage id="auth.options.signIn.forgotPassword" />
                </span>
              </div>
            </div>
            <div className="form__row">
              <div className="form__field-container">
                <Button
                  type="submit"
                  onClick={e => {
                    e.preventDefault();
                    submitForm();
                  }}
                  data-test-id="login-submit"
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  <FormattedMessage id="auth.options.signIn.label" />
                </Button>
              </div>
            </div>
          </>
        )}
        {shouldShowFirstPartySignIn && shouldShowThirdPartySignIn && (
          <>
            <div
              className={classNames(
                'auth-step-options__divider',
                isWelcomeBack && 'auth-step-options__divider--no-margin'
              )}
            >
              <span className="auth-step-options__divider-line auth-step-options__divider-line--left"></span>
              Or
              <span className="auth-step-options__divider-line auth-step-options__divider-line--right"></span>
            </div>
          </>
        )}
        {shouldShowThirdPartySignIn && (
          <ThirdPartySignIn
            isEmbeddedAuth={isEmbeddedAuth}
            providers={thirdPartySignInConfig.providers}
            testIdPrefix={testIdPrefix}
          />
        )}
      </div>
    </div>
  );
};

export default SignIn;
